import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGridBox: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="grid-box, grid-9"><path d="M9.25 4V20" stroke="currentColor" strokeWidth="1.5"/><path d="M14.75 4V20" stroke="currentColor" strokeWidth="1.5"/><path d="M4 9.25H20" stroke="currentColor" strokeWidth="1.5"/><path d="M4 14.75H20" stroke="currentColor" strokeWidth="1.5"/><path d="M20.25 3.75H3.75V20.25H20.25V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconGridBox;
